import { render } from "./WithdrawPage.vue?vue&type=template&id=0faa9910&scoped=true"
import script from "./WithdrawPage.vue?vue&type=script&lang=js"
export * from "./WithdrawPage.vue?vue&type=script&lang=js"

import "./WithdrawPage.vue?vue&type=style&index=0&id=0faa9910&scoped=true&lang=css"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faa9910"]])

export default __exports__